import { transformToArray } from '../../utils/TranslationUtil';
import { languageList } from '../../utils/LocaleUtil/languageList';
import { eglinks } from '../EgFooter/eglinks';

const companyNames = {
    expedia: 'Expedia, Inc.',
    vrbo: 'Vrbo,',
    eg: 'Expedia Group.'
};

// following locales don't use short names
const lpsShortNameExclusions = {
    zh_CN: 'zh-cn',
    zh_TW: 'zh-TW',
    pt_PT: 'pt-pt',
    pt_BR: 'pt-br'
};

const links = {
    ...eglinks.expedia,
    aboutUs: eglinks.eg.aboutUs
};


const DEFAULT_LOCALE = 'en_US';
const DEFAULT_SHORT_NAME = 'en';

const getLanguage = locale => languageList.find(lang => lang.locale === locale)
    || getLanguage(DEFAULT_LOCALE);

const getLocaleShortName = locale => lpsShortNameExclusions[locale]
    || (locale && locale.split('_')[0]) || DEFAULT_SHORT_NAME;

const getExpediaLinks = (locale) => {
    const language = getLanguage(locale);
    const shortName = getLocaleShortName(locale);
    const expediaLinks = links;

    return transformToArray({
        aboutUs: expediaLinks.aboutUs.replace('{localeShort}', shortName),
        termsOfUse: expediaLinks.termsOfUse.replace('{localeShort}', shortName),
        privacyPolicy: expediaLinks.privacyPolicy.replace('{localeShort}', shortName),
        cookiePolicy: expediaLinks.cookiePolicy.replace('{localeShort}', shortName),
        partnerHelp: expediaLinks.partnerHelp.replace('{langId}', language.langId),
        euVacationAgreement: expediaLinks.euVacationAgreement.replace('{langId}', language.langId)
    });
};

export {
    getExpediaLinks,
    companyNames
};
